module.exports = __webpack_public_path__ + "9dfb7138616749e1a83716c4ac13e9be.png";